export default __webpack_public_path__ + "purple-icon-dark.svg";